import * as yup from 'yup';
import { getEnterValidTextMessage, getMaxCharactersTextMessage, getMinCharactersTextMessage, getRequiredTextMessage } from '..';
import { YPhoneValidate } from '../yupValidators';
export const newTeamMemberValues = {
  firstName: '',
  lastName: '',
  email: '',
  phone: ''
};
export const newTeamMemberSchema = yup.object({
  firstName: yup.string().trim().min(2, getMinCharactersTextMessage('general.first_name', 2)).max(50, getMaxCharactersTextMessage('general.first_name', 50)).required(getRequiredTextMessage('general.first_name')),
  lastName: yup.string().trim().min(2, getMinCharactersTextMessage('general.last_name', 2)).max(50, getMaxCharactersTextMessage('general.last_name', 50)).required(getRequiredTextMessage('general.last_name')),
  email: yup.string().trim().email(getEnterValidTextMessage('general.email_address')).required(getRequiredTextMessage('general.email_address')),
  phone: YPhoneValidate
});